import { ValidationProvider } from "vee-validate";
import { consoleWarn } from "vuetify/lib/util/console";

export default {
	name: "KValidationProvider",

	inheritAttrs: false,

	/* eslint-disable no-undefined */
	props: {
		validationName: {
			default: undefined,
			type: String
		},
		validationId: {
			default: undefined,
			type: String
		},
		validationImmediate: Boolean,
		validationMode: {
			default: "eager",
			type: String
		},
		validationBails: {
			default: undefined,
			type: Boolean
		},
		validationDebounce: {
			default: 600,
			type: Number
		},
		validationRules: {
			default: undefined,
			type: [ Object, String ]
		},
		value: { required: false }
	},
	/* eslint-enable no-undefined */

	data: () => ( {
		errorMessages: []
	} ),

	computed: {
		internalValue: {
			get() {
				return this.value;
			},

			set( val ) {
				this.$emit( "input", val );
			}
		}
	},

	methods: {
		genValidationProvider() {
			if ( typeof this.genValidatableField !== "function" ) {
				consoleWarn( "genValidatableField method not defined", this );
				return null;
			}

			return <ValidationProvider
				bails={this.validationBails}
				debounce={this.validationDebounce}
				immediate={this.validationImmediate}
				mode={this.validationMode}
				name={this.validationName}
				rules={this.validationRules}
				scopedSlots={{
					default: props => {
						this.errorMessages = props.errors;

						return this.genValidatableField( props );
					}
				}}
				slim
				vid={this.validationId}
			></ValidationProvider>;
		}
	},

	beforeCreate() {

		// We manually assign error messages in our validation provider
		this.$delete( this.$options.props, "errorMessages" );
	}
};
